//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            details: [
                'Laravel framework.',
                'UX gebaseerd op processen uit de praktijk.',
                'Combinatie van hardware en software met AWS IoT.',
                'Diverse API koppelingen met branchespecifieke pakketten.',
            ],
        };
    },
    head: {
        meta: [
            {
                hid: 'og:title',
                name: 'og:title',
                content:
                    'Inzichtelijke bedrijfssoftware, geschikt voor ieder bedrijf in de recyclingbranche.',
            },
        ],
        title: 'Inzichtelijke bedrijfssoftware, geschikt voor ieder bedrijf in de recyclingbranche.',
    },
};
